import request from '@/utils/request'
import {h5Request} from '@/utils/h5Request';
import url from '../../config/server.js'


export function getVerifyCode(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.user.sms.send')
  })
}

export function login(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.user.login')
  })
}

export function getClockInfo(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.clock.info.get')
  })
}

export function getHomelandInfo(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.homeland.info.get')
  })
}
export function getRedPackData(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.redpacket.task')
  })
}

export function wxShare(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.weixin.share')
  })
}

export function downApp(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.download.url.get')
  })
}

export function openSum(params) {
  return request({
    url: url,
    method: 'post',
    data: h5Request(params, 'nologin.msg.open.sum')
  })
}

function getDataBygroupId(params) {
  return request({
    method: 'post',
    data: h5Request(params, 'nologin.chat.info.get')
  })
}

export default {
  getVerifyCode,
  getClockInfo,
  login,
  wxShare,
  getHomelandInfo,
  getRedPackData,
  downApp,
  openSum,
  getDataBygroupId
}



// WEBPACK FOOTER //
// ./src/api/register.js